import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes';
import { MultiItemSelector } from '../forms/multiItemSelector';

type Group = {
  id: string;
  name: string;
};

type GroupSelectorProps = {
  selectedGroups: Group[];
  availableGroups: Group[];
  onGroupsChange: (groups: Group[]) => void;
  onCreateGroup?: (name: string) => Promise<Group>;
  disabled?: boolean;
  useCropCircle?: boolean;
  onSelectorEdit?: () => void;
};

export const GroupSelector: React.FC<GroupSelectorProps> = ({
  selectedGroups,
  availableGroups,
  onGroupsChange,
  onCreateGroup,
  disabled = false,
  useCropCircle,
  onSelectorEdit,
}) => {
  const { t } = useTranslation();

  return (
    <MultiItemSelector
      selectedItems={selectedGroups}
      availableItems={availableGroups}
      onItemsChange={onGroupsChange}
      onCreateItem={onCreateGroup}
      disabled={disabled}
      placeholder={t('groups.common.selectGroup')}
      searchPlaceholder={t('groups.common.searchGroup')}
      createButtonText={t('groups.common.createGroup')}
      containerBackgroundColor={
        useCropCircle ? Colors.brand.white : Colors.white
      }
      itemType="group"
      emptyText={t('groups.common.emptyStateMessage')}
      useCropCircle={useCropCircle}
      onSelectorEdit={onSelectorEdit}
    />
  );
};
